'use client';

import { useEffect, useRef } from 'react';
import { EVENTS, track } from '@/lib/analytics';

interface Props {
  frontId: string;
  matchesCount: number;
  differentCount: number;
}

/** Fires `gear_center_match_viewed` once per page view. Renders nothing. */
export default function CenterMatchViewed({ frontId, matchesCount, differentCount }: Props) {
  // Guards React's development double-invoke; a client-side navigation to
  // another front speaker changes `frontId` and counts as a new view.
  const sent = useRef<string | null>(null);
  useEffect(() => {
    if (sent.current === frontId) return;
    sent.current = frontId;
    track(EVENTS.gear_center_match_viewed, { front_id: frontId, matches_count: matchesCount, different_count: differentCount });
  }, [frontId, matchesCount, differentCount]);
  return null;
}
